import"./KlarnaUpsell.css.ts.vanilla.css";var r="tmrc4f0";export{r as paymentUpsellContainer};
